<template>
  <lm-help-tip icon="link">
    <h1 class="mb-2 text-xs uppercase font-mono tracking-wider">Scope</h1>
    <ul class="max-h-100 overflow-y-auto">
      <li
        v-for="actor in managedActors"
        :key="actor._id"
        class="mb-1 mr-5"
        :class="'text-' + actor.color"
      >
        {{ actor.name }}
      </li>
    </ul>
  </lm-help-tip>
</template>

<script>
import {mapGetters} from 'vuex'
import LmHelpTip from '@/components/ui/LmHelpTip'
export default {
  name: 'LmManagerScopeHelper',
  components: {LmHelpTip},
  props: {
    actors: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(['getActorByID', 'getActors']),
    managedActors() {
      return this.actors.length === 0
        ? this.getActors
        : this.actors
            .map(actorId => this.getActorByID(actorId))
            .filter(actor => !!actor) // Filter out broken refs to deleted actors
    }
  }
}
</script>

<style scoped>
.LmManagerScopeHelper {
  &-list {
    max-height: 350px;
    overflow-y: auto;
  }
}
</style>
